export default __webpack_public_path__ + "static/media/akali-bg.1d74880e.jpg";